var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"ml-1",attrs:{"right":"","variant":"info","boundary":"viewport"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('i',{staticClass:"fa fa-indent mr-2"}),_c('span',[_vm._v("Options")])]},proxy:true}])},[(_vm.has('pm.orders.view'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{
      name: 'Orders.Index',
      query: { projectId: _vm.project.id }
    }}},[_vm._v(" Orders ")]):_vm._e(),(_vm.has('pm.other.systemLogs'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{
      name: 'ActionLog',
      query: { warehouseId: _vm.project.id }
    }}},[_vm._v(" Action Log ")]):_vm._e(),(_vm.has('pm.other.userLogs'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'UserLog', query: { warehouseId: _vm.project.id } }}},[_vm._v(" User Log ")]):_vm._e(),(_vm.has('pm.reports.storefrontProdStats'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{
      name: 'Reports.StorefrontProductStatistics',
      params: { projectId: _vm.project.id }
    }}},[_vm._v(" Storefront Inventory Stats ")]):_vm._e(),(_vm.has('pm.reports.wmsProdStats'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{
      name: 'Reports.WarehouseProductStatistics',
      params: { projId: _vm.project.id }
    }}},[_vm._v(" Warehouse Inventory Stats ")]):_vm._e(),(_vm.has('pm.warehouses.items.view'))?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{
      name: 'Warehouses.Items',
      query: {
        brandId: _vm.project.brandId,
        warehouseId: _vm.project.warehouseId
      }
    }}},[_vm._v(" Warehouse Items ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }